import { Component, Prop, h } from '@stencil/core';

import { trackInventoryClick } from '../../../tracking/tracking.dealer';
import { getDealerListVehicleImageURL } from '../../../utils/utils.dealer-list';

@Component({
  tag: 'inventory-listing',
  styleUrl: 'inventory-listing.css',
})
export class InventoryListing {
  @Prop() detailsUrl: string = '';
  @Prop() model: string = '';
  @Prop() make: string = '';
  @Prop() matchInventory: number = 0;
  @Prop() price: string = '';
  @Prop() updateGlobalState: string = '';
  @Prop() vehicleImageURL: string = '';
  @Prop() vehicleType = '';
  @Prop() year: string = '';
  @Prop() index: number;

  fullImageUrl = this.vehicleImageURL && getDealerListVehicleImageURL(this.vehicleImageURL);

  render() {
    return (
      <ico-hyperlink
        class="md:ml-3 mt-3 block"
        href={this.detailsUrl}
        target="_blank"
        onClick={() => trackInventoryClick(this.matchInventory === 1 ? 'exact' : 'partial', this.index)}>
        <div class="flex mdLrg:flex-col items-center mdLrg:w-28">
          <div class="w-28">
            <div class="bg-clrs-dark-green text-xs text-center text-clrs-white">{this.matchInventory === 1 ? 'Exact Match' : 'Partial Match'}</div>
            <img src={this.fullImageUrl} class="w-full  h-16"></img>
          </div>
          <div class="ml-2 mdLrg:ml-0 text-sm mdLrg:text-xs">
            <div>
              {this.vehicleType} {this.year} {this.make} {this.model}
            </div>
            <div class="font-bold">{this.price}</div>
          </div>
        </div>
      </ico-hyperlink>
    );
  }
}
